import { render, staticRenderFns } from "./VenD_VendorItemList_Input_List.vue?vue&type=template&id=f9683d70"
import script from "./VenD_VendorItemList_Input_List.vue?vue&type=script&lang=js"
export * from "./VenD_VendorItemList_Input_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports